import { isMobile } from '../../util';

const ProductBanner = ({
    accountId, sourceId, retailerId, placementId, locationId
}) => {
    return (
        <div className='surfside-menu-banner'>
            <surf-banner
                className='surf-ad-placement'
                account-id={accountId}
                channel-id="bf9bc"
                site-id={sourceId}
                placement-id={placementId}
                location-id={retailerId}
                keywords="product"
                width={isMobile() ? "4" : "8"}
                height={1}
            ></surf-banner>
        </div>
    );
};

export default ProductBanner;
